import TokenSession from "../session/TokenSession";

//TODO proper error handling
export default class UnauthorizedException extends Error {

	constructor(message: string, details?: any) {
		super(message);

		// kick back to the gateway
		TokenSession.refresh();
	}

}



// WEBPACK FOOTER //
// ./src/core/util/exception/UnauthorizedException.ts